import { useEffect, useRef, useState } from "react";
import { ThemeToggle } from "components";
import { HiBars3BottomRight, HiOutlineArrowLeft } from "react-icons/hi2";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.scss";

export default function Navbar() {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const links = [
    { to: "/login", label: "تسجيل الدخول" },
    { to: "/register", label: "إنشاء حساب" },
    { to: "/contact-us", label: "تواصل معنا" },
  ];

  useEffect(() => {
    if (previousPathRef.current !== location.pathname) {
      setIsMenuOpen(false);
      previousPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  return (
    <div className="text-sm">
      <nav className="portal-topbar mx-auto w-full rounded-[1.75rem] px-3 py-3">
        <div className="mx-auto flex max-w-screen-2xl flex-row-reverse items-center justify-between gap-4 px-2 md:px-3">
          <Link to="/" className="flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <p className="text-xs font-black uppercase tracking-[0.28em] portal-accent">
                SHAM
              </p>
              <p
                className="text-sm font-bold"
                style={{ color: "var(--layout-text)" }}
              >
                الشحن الرقمي
              </p>
            </div>
            <img
              className="w-11 drop-shadow-lg"
              src="/assets/images/clientLogo.png"
              alt="SHAM"
            />
          </Link>

          <button
            type="button"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            className="portal-outline-button inline-flex h-10 w-10 items-center justify-center rounded-xl lg:hidden"
          >
            <HiBars3BottomRight className="text-xl" />
          </button>

          <div className="hidden items-center gap-2 lg:flex">
            <ThemeToggle
              floating={false}
              sizeClassName="inline-flex h-10 w-10 rounded-xl p-0"
            />

            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-xl px-4 py-2 font-bold transition ${
                  location.pathname === link.to
                    ? "portal-outline-button"
                    : "portal-accent"
                }`}
              >
                {link.label}
              </Link>
            ))}

            {/* <Link
              to="/register"
              className="portal-accent-bg inline-flex items-center gap-2 rounded-xl px-4 py-2 font-bold text-white"
            >
              ابدأ الآن
              <HiOutlineArrowLeft />
            </Link> */}
          </div>
        </div>

        {isMenuOpen ? (
          <div className="mt-3 grid gap-2 border-t border-white/10 pt-3 lg:hidden">
            <div className="flex justify-start">
              <ThemeToggle
                floating={false}
                sizeClassName="inline-flex h-10 w-10 rounded-xl p-0"
              />
            </div>
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="portal-outline-button rounded-xl px-4 py-3 text-right font-bold"
              >
                {link.label}
              </Link>
            ))}
          </div>
        ) : null}
      </nav>
    </div>
  );
}
